<div class="centered-container p-d-flex p-justify-center p-ai-center">

  <!-- Nedostaje paket -->
  <div *ngIf="reason === 'paket'" class="card">
    <div class="icon-wrapper package">
      <i class="pi pi-box"></i>
    </div>
    <h1 class="title">Nemate potreban paket</h1>
    <p class="subtitle">
      Stranica kojoj pokušavate da pristupite zahteva aktivnu pretplatu na određeni paket
      koji trenutno nije uključen u Vaš plan.
    </p>
    <p class="description">
      Nadogradite Vaš paket kako biste dobili pristup ovoj i sličnim funkcionalnostima.
    </p>
    <div class="actions">
      <kodit-button
        btnLabel="Idi nazad"
        btnIcon="pi pi-arrow-circle-left"
        (btnClicked)="goBack()"
      ></kodit-button>
    </div>
    <div class="contact-section">
      <h2 class="contact-title">Zainteresovani za nadogradnju?</h2>
      <p class="contact-text">Kontaktirajte naš prodajni tim i saznajte koji paket vam najviše odgovara.</p>
      <div class="contact-grid">
        <div class="contact-block">
          <h3>Prodaja i ponude</h3>
          <p class="contact-line">Telefon: <a href="tel:+381606699361">+381 60 669 9361</a></p>
          <p class="contact-line">E-mail: <a href="mailto:prodaja@ekompanija.com">prodaja&#64;ekompanija.com</a></p>
        </div>
        <div class="contact-block">
          <h3>Korisnička podrška</h3>
          <p class="contact-line">Telefon: <a href="tel:{{KORISNICKA_PODRSKA_MOBILE_HREF}}">{{KORISNICKA_PODRSKA_MOBILE}}</a></p>
          <p class="contact-line">E-mail: <a href="mailto:podrska@ekompanija.com">podrska&#64;ekompanija.com</a></p>
        </div>
      </div>
    </div>
  </div>

  <!-- Nedostaje permisija -->
  <div *ngIf="reason === 'permisija'" class="card">
    <div class="icon-wrapper permission">
      <i class="pi pi-lock"></i>
    </div>
    <h1 class="title">Nemate potrebnu permisiju</h1>
    <p class="subtitle">
      Nemate dozvolu za pristup ovoj stranici.
    </p>
    <p class="description">
      Svaki korisnik u sistemu ima precizno definisana prava pristupa. Ukoliko Vam je
      potreban pristup ovoj funkcionalnosti, obratite se našoj tehničkoj podršci.
    </p>
    <div class="actions">
      <kodit-button
        btnLabel="Idi nazad"
        btnIcon="pi pi-arrow-circle-left"
        (btnClicked)="goBack()"
      ></kodit-button>
    </div>
  </div>

  <!-- Generički fallback -->
  <div *ngIf="reason === null" class="card">
    <div class="icon-wrapper permission">
      <i class="pi pi-ban"></i>
    </div>
    <h1 class="title">Pristup odbijen</h1>
    <p class="subtitle">Nemate pravo pristupa ovoj stranici.</p>
    <div class="actions">
      <kodit-button
        btnLabel="Idi nazad"
        btnIcon="pi pi-arrow-circle-left"
        (btnClicked)="goBack()"
      ></kodit-button>
    </div>
    <div class="contact-section">
      <h2 class="contact-title">Zainteresovani za nadogradnju?</h2>
      <p class="contact-text">Kontaktirajte naš prodajni tim i saznajte koji paket vam najviše odgovara.</p>
      <div class="contact-grid">
        <div class="contact-block">
          <h3>Prodaja i ponude</h3>
          <p class="contact-line">Telefon: <a href="tel:+381606699361">+381 60 669 9361</a></p>
          <p class="contact-line">E-mail: <a href="mailto:prodaja@ekompanija.com">prodaja&#64;ekompanija.com</a></p>
        </div>
        <div class="contact-block">
          <h3>Korisnička podrška</h3>
          <p class="contact-line">Telefon: <a href="tel:{{KORISNICKA_PODRSKA_MOBILE_HREF}}">{{KORISNICKA_PODRSKA_MOBILE}}</a></p>
          <p class="contact-line">E-mail: <a href="mailto:podrska@ekompanija.com">podrska&#64;ekompanija.com</a></p>
        </div>
      </div>
    </div>
  </div>

</div>
